// ======================================================================
// File: PRStatusBadge.jsx
// Module: PPE → Procurement → Purchase Request
//
// Purpose:
// - Display PR lifecycle status badge
// - UI identical to Indent status badge
// ======================================================================

import React from "react";

const STATUS_CLASS_MAP = {
  DRAFT: "status-draft",
  SUBMITTED: "status-submitted",
  APPROVED: "status-approved",
  PARTIALLY_ORDERED: "status-partial",
  FULLY_ORDERED: "status-complete",
  CLOSED: "status-closed",
};

export default function PRStatusBadge({ status }) {
  if (!status) return null;

  return (
    <span className={`erp-status ${STATUS_CLASS_MAP[status] || ""}`}>
      {status.replaceAll("_", " ")}
    </span>
  );
}
